import { formatDate } from '@angular/common';
import { DatiqRulesIsTypes } from '@dat/datiq-core/models';

export const DATIQ_SCHEDULER_RULES_TYPE_KEY: string = 'scheduler';

export const DATIQ_SCHEDULER_COMPARISON_MAP: any = {
    [DatiqRulesIsTypes.Later]: 'later$',
    [DatiqRulesIsTypes.Earlier]: 'earlier$',
};

export const DATIQ_SCHEDULER_TIME_FORMAT: string = 'HH:mm';

export const datiqSchedulerGetTimeFormat = (date: Date): string => {
    return formatDate(date, DATIQ_SCHEDULER_TIME_FORMAT, 'en-US');
};
